import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../../../store/store';

interface CultureHubBioState {
  selectedTeamMemberId: number | null;
}

const initialState: CultureHubBioState = {
  selectedTeamMemberId: null,
};

const cultureHubBioSlice = createSlice({
  name: 'cultureHubBio',
  initialState,
  reducers: {
    setSelectedTeamMember(state, action: PayloadAction<number | null>) {
      state.selectedTeamMemberId = action.payload;
    },
    resetBio() {
      return initialState;
    },
  },
});

export const { setSelectedTeamMember, resetBio } = cultureHubBioSlice.actions;

// Base selector
const selectBioState = (state: RootState) => state.cultureHubBio;

// Memoized selector with reselect
export const getSelectedTeamMember = createSelector(
  [selectBioState],
  (state): number | null => state.selectedTeamMemberId
);

export default cultureHubBioSlice;
